<template>
    <div>
        <active-forms-grid :showBtns="showBtns"
                           :returnUrl="'/forms/active'">
        </active-forms-grid>
    </div>
</template>

<script>
    import ActiveFormsGrid from '@/components/forms/ActiveFormsGrid';

    export default {
        name: 'list-active-forms-data',
        components: {
            ActiveFormsGrid
        },
        props: {
            showBtns: {
                default: true,
                type: Boolean
            }
        }
    }
</script>

<style scoped>
</style>
